"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _cell = require("./cell");

/**
 * Row of the sheet.
 * ```js
 * const row = sheet.addRow();
 * row.setHeightCM(0.8);
 * ```
 */
var Row = /*#__PURE__*/function () {
  /**
   * Row height
   * @type {Number}
   */
  function Row(_ref) {
    var sheet = _ref.sheet;
    (0, _classCallCheck2.default)(this, Row);
    (0, _defineProperty2.default)(this, "cells", []);
    (0, _defineProperty2.default)(this, "hidden", false);
    (0, _defineProperty2.default)(this, "height", 0);
    (0, _defineProperty2.default)(this, "outlineLevel", 0);
    (0, _defineProperty2.default)(this, "isCustom", false);
    this.sheet = sheet;
  }
  /**
   * Set height of the Row with `cm` unit.
   * @param {Number} ht Height with `cm` unit
   */


  (0, _createClass2.default)(Row, [{
    key: "setHeightCM",
    value: function setHeightCM(ht) {
      this.height = ht * 28.3464567;
      this.isCustom = true;
    }
    /**
     * Create a cell and add it into the Row.
     * @return {Cell}
     */

  }, {
    key: "addCell",
    value: function addCell() {
      var cell = new _cell.Cell({
        row: this
      });
      this.cells.push(cell);
      this.sheet.maybeAddCol(this.cells.length);
      return cell;
    }
  }]);
  return Row;
}();

exports.Row = Row;